module.exports = __webpack_public_path__ + "img/bglogin.4f651e32.png";